import { Component, Input, OnInit } from '@angular/core';
import { Transaction } from '../../models';

@Component({
  selector: 'app-merchant-logo',
  templateUrl: './merchant-logo.component.html',
  styleUrls: ['./merchant-logo.component.scss']
})
export class MerchantLogoComponent implements OnInit {

  @Input() user: Transaction;

  constructor() { }

  ngOnInit() {
  }

}
